(() => {
  // Capture before theme/app checkout shortcuts; keep working after AJAX cart updates.
  const validateAcknowledgement = (form, event) => {
    if (!form || !['cart', 'CartDrawer-Form'].includes(form.id)) return;
    const acknowledgement = Array.from(form.elements).find(
      (element) => element.matches('[data-jb-preorder-checkbox]')
    );
    if (!acknowledgement) return;
    // A valid cart uses the native POST so its acknowledgement attribute is saved.
    if (acknowledgement.checked) {
      event.stopImmediatePropagation();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    acknowledgement.focus();
    acknowledgement.reportValidity();
  };

  window.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (checkoutButton) validateAcknowledgement(checkoutButton.form, event);
  }, true);

  window.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement) {
      validateAcknowledgement(event.target, event);
    }
  }, true);
})();
